// extracted by mini-css-extract-plugin
module.exports = {"duikDatepicker":"DuikSelectDate-module__duikDatepicker___5BDQN"};